import { render, staticRenderFns } from "./companyNews.vue?vue&type=template&id=d6cdaf24&scoped=true"
import script from "./companyNews.vue?vue&type=script&lang=js"
export * from "./companyNews.vue?vue&type=script&lang=js"
import style0 from "./companyNews.vue?vue&type=style&index=0&id=d6cdaf24&prod&lang=scss"
import style1 from "./companyNews.vue?vue&type=style&index=1&id=d6cdaf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cdaf24",
  null
  
)

export default component.exports